import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getStockManufacturedItems({ commit }, params = {}) {
    return axios.get('/stock_manufactured_items/search', { params })
  },
  getStockManufacturedItem({ commit }, id) {
    return axios.get(`/stock_manufactured_items/${id}`)
  },
}
